import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let SBProFooter = class SBProFooter extends Vue {
};
__decorate([
    Prop()
], SBProFooter.prototype, "footerClasses", void 0);
SBProFooter = __decorate([
    Component({})
], SBProFooter);
export default SBProFooter;
